/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Events } from '@app/events/events/events.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class EventsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/events', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((event: any) => {
          return new Events().deserialize(event);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(event: Events): Observable<Events> {
    return this.http.put('v1/events/' + event.id, event).pipe(
      map((response: HttpResponse) => {
        return new Events().deserialize(response.data);
      })
    );
  }

  store(event: Events): Observable<Events> {
    return this.http.post('v1/events', event).pipe(
      map((response: HttpResponse) => {
        return new Events().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/events/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Events().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/events/' + id);
  }

  updateTranslations(events: Events, translations: any): Observable<any> {
    return this.http.put('v1/events/translations/' + events.id, translations).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
